import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

// 子コンポーネントの render エラーを捕捉して画面全体の真っ白化を防ぐ。
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }): void {
    // 本番ではコンソールにスタックを残す。Sentry 等への送信を増やすならここに足す。
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  reset = (): void => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-ink-50 dark:bg-ink-900 text-ink-800 dark:text-ink-100">
          <div className="card max-w-device w-full">
            <h2 className="card-title text-rose-600 dark:text-rose-400">
              アプリでエラーが発生しました
            </h2>
            <p className="mt-2 text-xs whitespace-pre-wrap text-ink-700 dark:text-ink-200">
              {this.state.error.message}
            </p>
            <button
              onClick={this.reset}
              className="mt-4 inline-flex items-center rounded-full bg-ink-900 dark:bg-ink-100
                         text-ink-50 dark:text-ink-900 px-4 py-1.5 text-sm font-medium"
            >
              リトライ
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
